import React, { useEffect, useState } from "react";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import NotificationsBell from "./NotificationsBell";
import MyWorkDrawer from "./MyWorkDrawer";
import { getCurrentVersion } from "../services/api";

const FALLBACK_VERSION = "v0.2.0";

export default function AppShell({
  headerSubtitle,
  headerRight,
  footerRightText = null,
  children,
}) {
  const [version, setVersion] = useState(FALLBACK_VERSION);

  useEffect(() => {
    getCurrentVersion().then(setVersion);
  }, []);

  // LLM197 + LLM177: bell + My Work drawer live next to headerRight on every
  // authed page. AppShell sits behind ProtectedRoute everywhere it's used, so
  // we don't need an extra auth check here.
  const right = (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <MyWorkDrawer />
      <NotificationsBell />
      {headerRight}
    </div>
  );

  return (
    <div className="page-root">
      <div className="container">
        <AppHeader subtitle={headerSubtitle} right={right} />
        {children}
        <AppFooter version={version} rightText={footerRightText} />
      </div>
    </div>
  );
}
